var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMaxSize, IsArray, IsString, MaxLength } from 'class-validator';
/**
 * Body for editing the allowed-origin allowlist of an existing embed key.
 * An empty list is permitted — it means "this key can currently boot on no
 * domain" — so a practice can lock a key without revoking it.
 */
export class UpdateEmbedKeyOriginsDto {
    allowedOrigins;
}
__decorate([
    IsArray(),
    ArrayMaxSize(50),
    IsString({ each: true }),
    MaxLength(255, { each: true }),
    __metadata("design:type", Array)
], UpdateEmbedKeyOriginsDto.prototype, "allowedOrigins", void 0);
//# sourceMappingURL=update-embed-key-origins.dto.js.map